import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "event-title"
}
const _hoisted_2 = { class: "glow-text" }

import { ref, onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'EventTip',
  props: {
    title: {},
    duration: {}
  },
  setup(__props: any) {

const props = __props

const visible = ref(false)

onMounted(() => {
  visible.value = true
  setTimeout(() => {
    visible.value = false
  }, props.duration ?? 2000)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "event-fade" }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})